import React, { useEffect } from "react";
import { useState } from "react";
import * as R from 'ramda';
import { Menu } from '@headlessui/react';
import _ from "lodash";
import { colorMapping } from "../services/utils";
import { settings } from "../../redux/settings/actions";
import { cancelReasons } from "../../redux/cancel-reasons/action";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { CancelReasonComponents } from "./cancel-reasons.component";
import { selectCancelReasonsListItems } from "../../redux/cancel-reasons/selector";
import { useSelector } from "react-redux";
import { selectCurrent } from "../../redux/settings/selectors";
import CommonModal from "../../models/common-modal";
export function LibraryRendererComponent({ cellRendererParams, value, columnData, dataId,rowData, onMobilityStatusClick }: any) {
  const [libraryElement, setLibraryElement] = useState<string>("");
  const [anchorOrderEl, setAnchorOrderEl] = React.useState(null);
  const cancelitemsData = useSelector(selectCancelReasonsListItems)
  const { getCommonModal } = useAppSelector(selectCurrent)
  const dispatch = useAppDispatch()
  const [
    colorDecider,
    setColorDecider
  ] = useState<any>();
  const [isCancel, setIsCancel] = useState<boolean>(false)
  const [
    selectedValue,
    setSelectedValue
  ] = useState<any>();
  const onFormChange: any = ({ field, value }: any) => {
    setSelectedValue({ ...selectedValue, [field]: value })
  }
  const handleCancelation = () => {
    return (
      <CancelReasonComponents
        cancelreason={cancelitemsData?.result?.items}
        onFormChange={onFormChange}
        selectedValue={selectedValue}
      />
    );
  };
const handleMenuClose = () => {
  setAnchorOrderEl(null);
};  const handleRejectOpen = async () => {
    await setIsCancel(true)
    await dispatch(settings.set({ getCommonModal: 'open' }))

    await dispatch(cancelReasons.list({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/dom/cancel-reasons/list`, entity: 'cancelReasons', jsonData: {

        Filters: [
          {
            FieldName: 'CanceledBy',
            FilterOperatorId: 6,
            FieldValue: 30,
            FieldType: 'text'
          }
        ]


      }
    }))

  };
 
  const handleOrderSubmit = (value: any) => {
    if (cellRendererParams?.callback) {
      console.log("Invoking callback with value:", value);
      cellRendererParams.callback(value);
    } else {
      console.error("Callback function is not defined in cellRendererParams");
    }
    handleMenuClose();
  };
  const getDisplayText = (item: any) => {
    const key = cellRendererParams?.menuKey || "Value";
    const value = cellRendererParams?.menuValue || "Text";
    return {
      display: item[value] || item["Text"] || "",
      value: item[key] || item["Value"] || "",
    };
  };

  const getAnchorStyles = (position: string) => {
    switch (position) {
      case "top-right":
        return { top: 0, right: 0 };
      case "top-left":
        return { top: 0, left: 0 };
      case "bottom-right":
        return { bottom: 0, right: 0 };
      case "bottom-left":
        return { bottom: 0, left: 0 };
      default:
        return { top: "100%", left: 0 }; // Default below button
    }
  };
  const [
    anchorJobStatusEl,
    setAnchorJobStatusEl
  ] = React.useState(null);
  const getRandomTextColor = () => {
    const red = Math.floor(Math.random() * 128);
    const green = Math.floor(Math.random() * 128);
    const blue = Math.floor(Math.random() * 128);
    const hexRed = red.toString(16).padStart(2, "0");
    const hexGreen = green.toString(16).padStart(2, "0");
    const hexBlue = blue.toString(16).padStart(2, "0");

    const hexCode = `#${hexRed}${hexGreen}${hexBlue}`;
    return hexCode;
  }

  const randomColor = getRandomTextColor();

  useEffect(() => {
    if (libraryElement && cellRendererParams?.isRowColorDecider) {
      const color = colorMapping[libraryElement] || "bg-gray-200";
      setColorDecider(color);
    }
  }, [libraryElement, cellRendererParams]);

  useEffect(() => {
    if (cellRendererParams?.library) {
      const libraryData = _.find(
        cellRendererParams?.library,
        (item: any) => item[cellRendererParams?.menuKey || "Value"] === value
      );
      setLibraryElement(
        libraryData ? libraryData[cellRendererParams?.menuValue || "Text"] : ""
      );
    }
  }, [cellRendererParams?.library, value, cellRendererParams?.menuKey, cellRendererParams?.menuValue]);
  const handleJobSubmit = (event: any) => {
    onMobilityStatusClick(
      event,
      dataId,
    )
    handleMenuClose()
  }
  const handleCancelationClose = () => {
    setSelectedValue({})
    setIsCancel(false)
    dispatch(settings.set({ getCommonModal: 'close' }))
  }
   const handleOrderCancelSubmit = () => {
    if (columnData?.[5]?.isMobilityJobEditable) {
      onMobilityStatusClick(
        -10,
        dataId,
        selectedValue?.Code
      )
    }
  }
  return (
    <div>

      {isCancel && getCommonModal == 'open' && <CommonModal title='Cancel Confirmation' renderForm={handleCancelation}
        onSubmit={handleOrderCancelSubmit}
        handleClose={handleCancelationClose}
      />}
      {cellRendererParams?.isRowMenuSelect ?
        <> {cellRendererParams?.library && (
          <Menu as="div" className="relative text-left">
            <div>
              <Menu.Button
                onClick={(e: any) => setAnchorOrderEl(e.currentTarget)}
                className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 text-gray whitespace-nowrap`}
                style={{ backgroundColor: getRandomTextColor() }}
              >
                {libraryElement || 'Select'}
              </Menu.Button>
            </div>
            {anchorOrderEl && (
              <Menu.Items
                style={getAnchorStyles(cellRendererParams?.anchorPosition || "default")}
                className="absolute fixed z-10 bg-white border border-gray-300 rounded shadow-lg w-auto p-1 overflow: visible"
              >
                <div className="px-1 py-1">
                  {_.map(cellRendererParams?.library, (item: any) => {
                    const { display, value } = getDisplayText(item);
                    return (
                      <Menu.Item key={value}>
                        <button
                          onClick={() => {
                            handleOrderSubmit(value);
                            handleMenuClose();
                          }}
                          className="p-2 hover:bg-gray-100 whitespace-nowrap"
                        >
                          {display}
                        </button>
                      </Menu.Item>
                    );
                  })}
                </div>
              </Menu.Items>
            )}
          </Menu>
        )}</> :
        <>
          <span
            className={`p-2 rounded-full text-black ${cellRendererParams?.isRowColorDecider ? colorDecider : ""}`}
            style={!cellRendererParams?.isRowColorDecider ? { backgroundColor: randomColor } : {}}
          >
            {columnData?.[5]?.isMobilityJobEditable ? (
              <Menu as="div" className="relative text-left inline-block">
                <Menu.Button
                  onClick={(e: any) => setAnchorJobStatusEl(e.currentTarget)}
                  className="py-1 px-2 text-sm font-normal rounded-xl text-black"
                >
                  {libraryElement || 'NA'}
                </Menu.Button>

                {anchorJobStatusEl && (
                  <Menu.Items className="absolute z-10 bg-white border border-gray-300 rounded shadow-lg w-44 p-1">
                    <div className="px-1 py-1">
                      <Menu.Item>
                        <button onClick={() => handleJobSubmit(20)} className="p-2 w-full text-black hover:bg-gray-100">
                          On the Way
                        </button>
                      </Menu.Item>
                      <Menu.Item>
                        <button onClick={() => handleJobSubmit(30)} className="p-2 w-full text-black hover:bg-gray-100">
                          Arrived
                        </button>
                      </Menu.Item>
                      <Menu.Item>
                        <button onClick={() => handleJobSubmit(40)} className="p-2 w-full text-black hover:bg-gray-100">
                          Service InProgress
                        </button>
                      </Menu.Item>
                      <Menu.Item>
                        <button onClick={() => handleJobSubmit(50)} className="p-2 w-full text-black hover:bg-gray-100">
                          Completed
                        </button>
                      </Menu.Item>
                      <Menu.Item>
                       <button
  onClick={async () => {
    handleMenuClose();
    setAnchorJobStatusEl(null);
    await handleRejectOpen();
  }}
  className="p-2 w-full text-black hover:bg-gray-100"
>
  Job Cancelled
</button>
                      </Menu.Item>
                    </div>
                  </Menu.Items>
                )}
              </Menu>
            ) : (
              libraryElement || 'NA'
            )}
          </span>
        </>
      }


    </div>
  );
}
